export const locales = {
  back: 'Zurück',
  close: 'Schließen',
  next: 'Weiter',
  skip: 'Überspringen',
  last: 'Fertig'
}
